export default __webpack_public_path__ + "static/media/i_bus-dbl_pp_tagless.629f7fa2.svg";